import { render, staticRenderFns } from "./CandidateListDetailsV2.vue?vue&type=template&id=37fb6e14&"
import script from "./CandidateListDetailsV2.vue?vue&type=script&lang=js&"
export * from "./CandidateListDetailsV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports